"use client";

/**
 * ReflectStillEchoing — bottom chip row showing the durable choices that
 * keep echoing across the week. Each chip is small, uppercase mini-label
 * + bold value. Empty slots are dropped silently rather than rendered as
 * "unknown" — better to show fewer, true chips than fake ones.
 */

import styles from "./reflect-page.module.css";

export interface ReflectStillEchoingChip {
  label: string;
  value: string;
}

export interface ReflectStillEchoingProps {
  chips: ReflectStillEchoingChip[];
}

export default function ReflectStillEchoing({
  chips,
}: ReflectStillEchoingProps) {
  if (chips.length === 0) {
    return (
      <p
        style={{
          margin: 0,
          fontSize: 13,
          color: "var(--textLight)",
          fontStyle: "italic",
        }}
      >
        Tone, long-term goals, and check-in cadence will appear here once
        you&apos;ve set a few preferences.
      </p>
    );
  }
  return (
    <div className={styles["rf-echoing"]}>
      {chips.map((c) => (
        <div key={`${c.label}-${c.value}`} className={styles["rf-chip"]}>
          <span className={styles["rf-chip-label"]}>{c.label}</span>{" "}
          <strong>{c.value}</strong>
        </div>
      ))}
    </div>
  );
}
